<!--<div class="modal-header">-->
<!--  <h4>{{ title }}</h4>-->
<!--  <button type="button" class="close" aria-label="Close" (click)="cancel()">-->
<!--    <span class="font-weight-light fs-20" aria-hidden="true">&times;</span>-->
<!--  </button>-->
<!--</div>-->
<div class="modal-header">
  <h4 class="modal-title pull-left">{{ title }}</h4>
  <button type="button" class="btn-close close pull-right fs-12" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true" class="visually-hidden font-weight-light">&times;</span>
  </button>
</div>
<div class="modal-body">{{ message }}</div>
<div class="modal-footer text-center">
  <button type="button" class="btn btn-outline-success" (click)="ok()">
    {{ okButton }}
  </button>
  <button type="button" class="btn btn-outline-danger" (click)="cancel()">
    {{ cancelButton }}
  </button>
</div>
